module.exports = __webpack_public_path__ + "static/media/ocean-wave.a0f57e0a.png";